module.exports = __webpack_public_path__ + "media/images/activity-indicator-light-7b03a972cc512a394c6667f45ddb6441.svg";